'use strict';
import { module } from '../app';
import * as _ from 'lodash';

module
  .factory('patientsListViewModel', [
    '$filter', 'Patient', 'modalService', 'ionicDatePicker', 'techpadConfig', 'techpadOptions', 'dateFormattingHelper', 'environmentHelper', 'datePickerService',
    function ($filter, Patient, modalService, ionicDatePicker, techpadConfig, techpadOptions, dateFormattingHelper, environmentHelper, datePickerService) {
      let vm = function () {
        let self = this;

        self.techpadSettings = techpadConfig.settings;
        techpadOptions.getOptions();
        self.darkMode = techpadOptions.options.DarkMode;
        self.isIOSDevice = environmentHelper.isIOSDevice();

        self.maxYear = new Date(new Date().getFullYear(), 11, 31).getFullYear();

        self.initFilter = function () {
          self.filter = {
            ssn: "",
            externalId: "",
            firstName: "",
            lastName: "",
            dob: "",
            simpleSearch: "",
            isIncludeAccessToken: true
          };
        };

        self.haveSearched = false;

        self.toggleAdvancedSearch = function () {
          self.isAdvancedSearch = !self.isAdvancedSearch;
          self.initFilter();
        };

        self.getPatientDisplayName = function (patient) {
          return patient.LastName + ', ' + patient.FirstName;
        };

        self.matchPatientName = function (patient, string) {
          let rules = [
            patient.LastName + ',' + patient.FirstName,
            patient.LastName + ', ' + patient.FirstName,
            patient.LastName + ' , ' + patient.FirstName
          ];

          return rules.some((rule) => rule.toLowerCase().indexOf(string.toLowerCase()) > -1);
        };

        self.getPatientSsn = function (patient) {
          return patient.Ssn;
        };

        self.getPatientExternalId = function (patient) {
          return patient.ExternalId;
        };

        self.search = function () {
          self.isSearching = true;
          let data = angular.copy(self.filter);
          data.dob = $filter('date')(self.filter.dob, 'MM/dd/yyyy');
          Patient.search(data)
                 .then((resp) => {
                   self.patients = !!self.filter.simpleSearch ?
                     resp.data.filter((patient) => {

                       return self.matchPatientName(patient, self.filter.simpleSearch) ||
                         self.getPatientSsn(patient).toLowerCase().indexOf(self.filter.simpleSearch.toLowerCase()) > -1 ||
                         techpadConfig.settings.UseAlternateUserIdentifier && self.getPatientExternalId(patient).toLowerCase().indexOf(self.filter.simpleSearch.toLowerCase()) > -1;
                     }) :
                     resp.data;

                 }, (resp) => {
                   let error = resp.data;
                   if (resp.status === 0) {
                     error = {errorId: 404, message: "Magview API url is not configured"};
                   }
                   modalService.showErrorMessage(error);
                 })
                 .finally(function () {
                   self.isSearching = false;
                   if (!self.haveSearched)
                     self.haveSearched = true;
                 });
        };

        self.searchOnKeyPress = function (event) {
          if (event.which === 13) {
            self.search();
            return;
          }
        };

        self.formatDOBValue = function(DateOfBirth) {
          return dateFormattingHelper.formatDateValue(DateOfBirth, self.maxYear);
        };

        self.changeDate = function () {
          let maxDate = new Date(new Date().getFullYear(), 11, 31);
          const changeDateModel = {
            obj: self.filter,
            id: 'dob',
            maxDate
          };
          datePickerService.changeDate(changeDateModel);
        };

        self.initFilter();
      };

      return vm;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/patientsList.js